import FishLogo from '@components/icons/FishLogo'
import { CustomerCreateFormValues } from '@features/account/api/customer-create'
import { M55SignupFormFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { useRouter } from 'next/router'
import { FC, useMemo, useState } from 'react'
import ConfirmAccountStep from './ConfirmAccountStep'
import ConfirmPage from './ConfirmPage'
import s from './M55SignupForm.module.scss'
import SendCodeStep from './SendCodeStep'

export type M55SignupFormProps = {
  className?: string
} & M55SignupFormFragment

const M55SignupForm: FC<M55SignupFormProps> = ({ className, ...props }) => {
  const [step, setStep] = useState(1)
  const [data, setData] = useState<CustomerCreateFormValues | null>(null)
  const [currentStep, setCurrentStep] = useState(1)

  const handleNext = (data: CustomerCreateFormValues) => {
    setData(data)
    setStep(2)
  }

  const router = useRouter()

  const emailField = router.query?.email as string

  const { customerSignupToken } = router.query as {
    customerSignupToken: string
  }

  let email, token

  try {
    const decodedToken = atob(customerSignupToken)
    ;[email, token] = decodedToken.split('|')

    if (!email || !token) {
      throw new Error('Decoded token format is invalid')
    }
  } catch (error) {
    console.log('Invalid or improperly formatted token:', error)
  }

  useMemo(() => {
    if (email && token) {
      return setStep(3)
    }
  }, [email, token])

  return (
    <div className={clsx('container', s.root, step === 3 && s.hasProgress)}>
      {step === 3 && (
        <div className={s.formWrapper}>
          <div
            className={s.stepIndicator}
            style={
              {
                '--step': currentStep,
              } as React.CSSProperties
            }
          />
          <span className={s.stepCounter}>Step {currentStep}/2</span>
        </div>
      )}
      <div className={s.headline}>SIGN UP</div>
      {step === 1 && (
        <SendCodeStep email={emailField} onNext={handleNext} {...props} />
      )}
      {step === 2 && (
        <ConfirmPage
          email={data.email}
          type={'SignUp'}
          text={props.confirmStepCheckEmailText}
        />
      )}
      {step === 3 && (
        <ConfirmAccountStep
          email={email}
          token={token}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />
      )}

      <FishLogo width={30} height={30} className="mx-auto" />
    </div>
  )
}

export default M55SignupForm
